'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateView = exports.updateViewAction = undefined;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var _views = require('../constants/views');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateViewAction = exports.updateViewAction = (0, _reduxActions.createAction)(_actionTypes.UPDATE_VIEW, function (view) {
  return { view: view };
});

var updateView = exports.updateView = function updateView(view) {
  return function (dispatch) {
    (0, _invariant2.default)([_views.THREAD_LIST, _views.THREAD_VIEW].indexOf(view) > -1, '`updateView` expected to be called with a valid `view` argument, but received "%s"', view);

    dispatch(updateViewAction(view));
  };
};